import { render, staticRenderFns } from "./ContainerIcon.vue?vue&type=template&id=5a74a640"
import script from "./ContainerIcon.vue?vue&type=script&lang=js"
export * from "./ContainerIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports